<div
	class="{{ 'card-header cursor-pointer ' + className }}"
	[ngClass]="isOpen ? 'bg-primary' : ''"
	(click)="itemToggled.emit()"
	[attr.aria-expanded]="isOpen"
	[attr.aria-controls]="'collapse-panel-' + id">
	<div class="d-flex justify-content-between align-items-center">
		<div [class.flex-fill]="centerTitle" class="itemHeaderTitle">
			<ng-content select="[header]"></ng-content>
		</div>
		<div
			[ngClass]="isOpen ? 'keyboard-arrowup-mask-img' : 'keyboard-arrowdown-mask-img'"
			class="enabled chevron mask-settings bg-dark cursor-pointer accordion-icon"
			style="height: 1.8rem; width: 1.8rem"></div>
	</div>
</div>
<div class="card-body" [class.px-0]="fitPaddingToHeader" [class.p-0]="noPadding" [ngbCollapse]="!isOpen" [id]="'collapse-panel-' + id">
	<ng-content select="[body]"></ng-content>
</div>
